import ArrowUpIcon from '../../../../../../../../../assets/icons/icon-arrow-up.svg?react'
import css from './TaskModalCommentsAddCommentSubmit.module.css'

interface TaskModalCommentsAddCommentSubmitProps {
    onClick: () => void
}

const TaskModalCommentsAddCommentSubmit = ({ onClick }: TaskModalCommentsAddCommentSubmitProps) => {
    return (
        <button className={css.button} onClick={onClick} data-testid="comment-submit-btn">
            <ArrowUpIcon />
        </button>
    )
}

export default TaskModalCommentsAddCommentSubmit
